import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import * as QueryString from 'query-string';
import { withRouter } from 'react-router-dom';

import { Http } from '../../../../support';
import Uuid from '../../../../support/Uuid';
import Loading from '../../../../facturotopia/loading/Loading';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import ResponseError from '../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../shared/responses/ResponseResult';
import TotalGlobalSummary from '../../../../app/comprobantes/create/components/TotalGlobalSummary';
import ReceptorFiscalInfoForm from '../../../../app/receptores/upsert/components/ReceptorFiscalInfoForm';
import ConceptosNotEditableList from '../../../../app/comprobantes/create/components/conceptos/ConceptosNotEditableList';
import CreateReceptorAccountOnTicketStamping from '../../../../external/autofacturacion/components/CreateReceptorAccountOnTicketStamping';

class TimbradoTicketRequest extends Component {
  state = {};

  cache = null;
  timer = null;

  constructor(props) {
    super(props);

    this.state = {
      data: {
        input: props.data ?? {},
      },
      busy: false,
      error: null,
      loading: false,
      fetching: false,
      downloaded: false,
    };
  }

  onReceptorFormDataChange = (event) => {
    const {
      data,
      data: { input = {} },
    } = this.state;

    const state = {
      data: {
        ...data,
        input: {
          ...input,
          Receptor: {
            ...event.data,
          },
        },
      },
      isValid: event.isValid,
    };

    this.setState({ ...state });

    const rfc = state.data.input.Receptor.rfc;

    if (!!rfc && !!rfc.trim() && rfc !== this.cache) {
      if (rfc.length >= 12 && ['XAXX010101000', 'XEXX010101000'].indexOf(rfc) === -1) {
        if (this.timer) {
          clearTimeout(this.timer);
        }

        this.timer = setTimeout(async () => {
          this.setState({
            fetching: true,
          });

          try {
            const query = QueryString.parse(this.props.location.search);

            const headers = {
              'X-Tenancy': query.tenancy,
            };

            const params = {
              rfc,
              tickets: state.data.input.tickets,
            };

            const response = await Http.get('/ext/receptores/autofacturacion/perfil', { params, headers });

            const {
              data,
              data: { input = {} },
            } = this.state;

            const newState = {
              data: {
                ...data,
                input: {
                  ...input,
                  Receptor: {
                    ...response,
                    cp: response.direccion?.cp,
                  },
                },
              },
            };

            this.setState({
              isValid: true,
              ...newState,
            });
          } catch (error) {
          } finally {
            this.setState({
              fetching: false,
            });
          }
        }, 1000);
      }

      this.cache = rfc;
    }
  };

  submit = async () => {
    const {
      data: { input },
    } = this.state;

    this.setState({
      busy: true,
    });

    try {
      const body = {
        ...input,
        Receptor: {
          Rfc: input.Receptor.rfc,
          Nombre: input.Receptor.razon_social,
          Email: input.Receptor.email,
          Regimen: input.Receptor.regimen,
          CP: input.Receptor.cp,
          UsoCFDI: input.Receptor.uso_cfdi,
          External: input.Receptor.external,
        },
      };

      const response = await Http.post(`api/autofacturacion/facturas`, body);

      this.setState({
        busy: false,
        result: response,
      });
    } catch (error) {
      this.setState({
        error: error.data || error,
        busy: false,
      });
    }
  };

  handleOnAction = () => {
    const { result } = this.state;

    window.location = result.data.link;

    this.setState({
      downloaded: true,
    });

    this.props.history.replace('/modulos/autofacturacion/tickets');
  };

  handleResetError = () => {
    this.setState({
      error: undefined,
    });
  };

  handleOnDone = () => {
    this.setState({
      data: {},
      result: undefined,
      error: undefined,
      downloaded: false,
    });
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleResetError}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result: _result, downloaded } = this.state;

    let result = {
      ..._result,
      message: _result.message + ' Si quieres descargar tu factura haz click en "Descargar"',
    };

    if (downloaded) {
      return (
        <div className="result-container">
          <ResponseResult
            title="Factura emitida."
            result={result}
            btnText="Continuar"
            onAction={this.handleOnDone}
          />
        </div>
      );
    }

    return (
      <div className="result-container">
        <ResponseResult
          title="Factura emitida."
          result={result}
          btnText="Descargar mi factura"
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const {
      busy,
      loading,
      data: { input },
      error,
      result,
    } = this.state;

    let { isValid } = this.state;

    if (!!input.Conceptos?.Concepto) {
      input.Conceptos.Concepto = input.Conceptos.Concepto.map((item) => {
        if (!item.id) {
          item = {
            ...item,
            id: Uuid.v4(),
          };
        }

        return item;
      });
    }

    if (loading) {
      return <Loading />;
    }

    return (
      <>
        <Row className="pt-3">
          <Col
            md={6}
            sm={true}
          >
            <div className="pb-3">
              <strong className="text-info text-uppercase">Generar factura</strong>
            </div>
          </Col>
        </Row>

        {!!result && this.renderResult()}

        {!!error && this.renderError()}

        <Row>
          <Col
            md={6}
            sm={true}
            className="py-3"
          >
            <div className="pb-3">
              <ReceptorFiscalInfoForm
                data={input.Receptor || {}}
                autoFocus={true}
                datos_fiscales_requeridos={true}
                autofacturacion={true}
                onFormDataChange={this.onReceptorFormDataChange}
              />

              {!!input.Receptor &&
                !!input.Receptor.email &&
                input.Receptor.rfc !== 'XAXX010101000' &&
                input.Receptor.rfc !== 'XEXX010101000' && (
                  <CreateReceptorAccountOnTicketStamping
                    data={input.Receptor || {}}
                    isValid={isValid}
                    onFormDataChange={this.onReceptorFormDataChange}
                  />
                )}
            </div>
          </Col>

          <Col
            md={6}
            sm={true}
            className="py-3"
          >
            Hola, para solicitar tu factura sigue los siguientes pasos:
            <br />
            <br />
            <s>1. Introduce el código proporcionado por el establecimiento.</s>
            <br />
            {!result && <span>2. Completa tu información fiscal.</span>}
            {!!result && <s>2. Completa tu información fiscal.</s>}
            <br />
            {!!result && <span>3. Guarda tu factura, adicionalmente la recibirás por email.</span>}
            <br />
            {!result && (
              <>
                <p className="text-danger">
                  <strong>NOTA IMPORTANTE !!!</strong>
                </p>

                <p>
                  Para <strong>CFDI 4.0</strong> debes ingresar la razón social <strong>sin régimen capital</strong>
                  .
                  <br />
                  <br />
                  Ejemplo:
                  <br />
                  Razón Social: <span className="text-dark">MI RAZON SOCIAL S.A. DE C.V</span>
                  <br />
                  Debe usarse: <span className="text-dark">MI RAZON SOCIAL</span> (Omitir el: S.A. DE C.V)
                </p>
              </>
            )}
          </Col>
        </Row>

        <Row>
          <Col
            sm={12}
            xs={true}
            className="pb-5"
          >
            <div className="pb-3">
              <strong className="text-info">Conceptos</strong>
            </div>

            <ConceptosNotEditableList
              data={!!input && !!input.Conceptos && !!input.Conceptos.Concepto ? input.Conceptos.Concepto : []}
            />

            <TotalGlobalSummary data={input} />

            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false || !!result}
              onClick={this.submit}
            >
              {busy ? 'Procesando...' : 'Facturar'}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(TimbradoTicketRequest);
